<!-- Comment <template>
  <div class="client">
    <div class="benvenuto">
        <div class="messaggio">
            Benvenuto Da Bagni Fiore
        </div>
        <div class="info">
            Puoi ordinare accedendo alla voce menù, o al cameriere cliccando X
        </div>
    </div>
    <div class="ordini">
        <span class="cameriere"  @click="goCallwaiter"><img alt="Camerie" class="img-cameriere" src="../assets/waiter.svg"/></span>
        <span class="menu" @click="goMenu">MENÙ</span>
        <span class="dolci-caffe" @click="goDolciCaffe">DOLCI E CAFFE</span>
        <span class="diconodinoi" @click="goDiconoDiNoi">DICONO DI NOI</span>
    </div>
  </div>
</template>
-->
<template>
<div class="client">
  <div class="up">
    <div class="logo">logo</div>
    <div class="welcome">{{ $t('client_welcome_msg') }}</div>

  </div>
  <div class="middle">
    <span class="menu" @click="goMenu">{{ $t('client_menu') }}</span>
    <span class="asporto" @click="goAsporto">{{ $t('client_asporto') }}</span>
    <span class="dolci-caffe" @click="goDolciCaffe">{{ $t('client_dolci') }}</span>
    <span class="diconodinoi" @click="goDiconoDiNoi">{{ $t('client_feedback') }}</span>
    <span class="cameriere"  @click="goCallwaiter"><img alt="Camerie" class="img-cameriere" src="../assets/waiter.svg"/></span>
  </div>
  <div class="down">{{ $t('client_footer') }}</div>


</div>
</template>

<script>
// @ is an alias to /src


export default {
  name: 'Benvenuto',
  data: function(){

      return {
        piatti:[]
      }
  },
  methods: {
    goMenu () {
      this.$router.push({ name: "Menu" })
       
    },
    goAsporto () {
      this.$router.push({ name: "OrdineAsporto" })
    },
    goProposte () {
      console.log(window.location.hash)
       
    },
    goDolciCaffe () {
       
    },
    goDiconoDiNoi () {
       
    },
    goCallwaiter () {
      
    },
    setTavolo() {
      console.log('settaggio tavolo')
      localStorage.setItem( 'tavolo', JSON.stringify(window.location.hash) );
    },
  },
  beforeMount() {
    this.setTavolo();
  },
}
</script>


<style scoped>
.client {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    flex-wrap: wrap;
    height: 95vh;
    
}

.up{
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  background-color: black;
  height: 30vh;
  color:white;
  line-height: 25vh;

}
.middle{
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  height: 35vh;
  color:black;
}
  
.down{
  display: flex;
  background-color: black;
  height: 30vh;
  color:white;
  justify-content: center;
  line-height: 25vh;

}

.img-cameriere  {
  width: 40px;
}
.menu, .dolci-caffe, .diconodinoi, .cameriere, .asporto {
  cursor: pointer;
}

.asporto {
  background: linear-gradient(90deg, #00d9ff, #00ff88);
  color: #1a1a2e;
  padding: 12px 24px;
  border-radius: 8px;
  font-weight: bold;
}


</style>